module.exports = __webpack_public_path__ + "static/media/joshua-stannard.f512e83c.jpg";